<template>
  <el-card class="box-card" shadow="always">
    <div class="form-item">
      <span class="label">*所属分类</span>
      <el-select v-model="seoInfo.case_class_id" class="icon_type">
        <el-option v-for="(item, index) in caseClassList" :key="index" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </div>

    <div class="form-item">
      <span class="label">*案例标题</span>
      <el-input
        v-model="seoInfo.case_title"
        clearable
        style="width: 300px"
        class="name-input"
        placeholder="请输入案例标题"
      />
    </div>
    <div class="form-item">
      <span class="label">*案例简介</span>
      <el-input
        v-model="seoInfo.case_introduce"
        clearable
        style="width: 300px"
        class="name-input"
        placeholder="请输入案例标题"
      />
    </div>
    <div class="form-item">
      <span class="label">*权重</span>
      <el-input
        v-model="seoInfo.sort"
        clearable
        style="width: 300px"
        class="name-input"
        placeholder="请输入 0～99，权重越大越靠前"
      />
    </div>
    <div class="form-item">
      <span class="label">*企业名称</span>
      <el-input
        v-model="seoInfo.case_enterprise_name"
        clearable
        style="width: 300px"
        class="name-input"
        placeholder="请输入企业名称"
      />
    </div>
    <div class="form-item">
      <span class="label">*项目背景</span>
      <el-input
        v-model="seoInfo.bg_content"
        clearable
        style="width: 300px"
        class="name-input"
        :rows="4"
        type="textarea"
        placeholder="请输入项目背景介绍"
      />
    </div>

    <div class="form-item">
      <span class="label">*案例封面:</span>
      <div>
        <imageUpload v-model="seoInfo.case_img" :limit="1" />
        <div class="el-upload__tip">建议尺寸为280*385</div>
      </div>
    </div>
    <div class="form-item">
      <span class="label">*案例短封面:</span>
      <div>
        <imageUpload v-model="seoInfo.case_sub_img" :limit="1" />
        <div class="el-upload__tip">建议尺寸为441*320</div>
      </div>
    </div>
    <div class="form-item">
      <span class="label">*案例banner:</span>
      <div>
        <imageUpload v-model="seoInfo.case_banner" :limit="1" />
        <div class="el-upload__tip">建议尺寸为1920*400</div>
      </div>
    </div>

    <div class="form-item">
      <span class="label">自定义ALT</span>
      <el-input
        v-model="seoInfo.case_icon_alt"
        clearable
        style="width: 300px"
        class="name-input"
        placeholder="请输入自定义ALT"
      />
    </div>

    <div>
      <!-- <div class="seo_set">*SEO配置</div> -->
      <!-- <div class="seo_wrap"> -->
        <!-- <div class="form-item">
          <span class="label">*页面标题：</span>
          <el-input
            v-model="seoInfo.seo_t"
            clearable
            style="width: 300px"
            class="name-input"
            placeholder="请输入页面标题："
          />
        </div>

        <div class="form-item">
          <span class="label co_w">*描述：</span>
          <el-input
            v-model="seoInfo.seo_d"
            clearable
            style="width: 300px"
            class="name-input"
            placeholder="请输入描述"
          />
        </div> -->

        <div class="form-item">
          <span class="label co_w">SEO关键词：</span>
          <el-input
            v-model="seoInfo.seo_k"
            clearable
            style="width: 300px"
            class="name-input"
            placeholder="请输入关键词"
          />
        </div>
      <!-- </div> -->
    </div>
  </el-card>
</template>
<script>
import { getCaseClass } from "@/api/case";
import utils from "@/jslibs/utils";
import imageUpload from "@/components/ImageUpload";
export default {
  components: {
    imageUpload,
  },
  data() {
    return {
      loading: false,
      seoInfo: {
        case_class_id: "",
        case_title: "",
        case_introduce: "",
        case_enterprise_name: "",
        bg_content: "",
        sort: "",
        case_banner:[],
        banner:'',
        case_sub_img:[],
        case_sub_icon:'',
        case_icon: "",
        case_img: [],
        case_icon_alt: "",
        seo_t: "",
        seo_d: "",
        seo_k: "",
      },
      caseClassList: [],
    };
  },
  mounted() {
    this.getCaseClass();
  },
  methods: {
    async getCaseClass() {
      const postData = { page_index: 1, page_size: 999 };
      const { data } = await getCaseClass(postData);
      this.caseClassList = data;
    },

    verifyInput() {
      const { case_class_id, case_title,case_introduce,sort,case_enterprise_name,bg_content, case_img,case_banner,case_sub_img, case_icon_alt, seo_t, seo_d, seo_k } = this.seoInfo;
      if (!case_class_id) {
        this.$notify.error({ title: "请选择所属分类" });
        return false;
      }
      if (!case_title) {
        this.$notify.error({ title: "请输入案例标题" });
        return false;
      }
      if (!case_introduce) {
        this.$notify.error({ title: "请输入案例简介" });
        return false;
      }
      if (!sort) {
        this.$notify.error({ title: "请输入权重" });
        return false;
      }
      if (!case_enterprise_name) {
        this.$notify.error({ title: "请输入企业名称" });
        return false;
      }
      if (!bg_content) {
        this.$notify.error({ title: "请输入项目背景" });
        return false;
      }
      if (!case_img.length) {
        this.$notify.error({ title: "请上传封面案例图" });
        return false;
      }
      if (!case_banner.length) {
        this.$notify.error({ title: "请上传banner例图" });
        return false;
      }
      if (!case_sub_img.length) {
        this.$notify.error({ title: "请上传短案例例图" });
        return false;
      }
      this.seoInfo.seo_t = case_title;
      this.seoInfo.seo_d = case_introduce;
      // if (!seo_t) {
      //   this.$notify.error({ title: "请输入页面标题" });
      //   return false;
      // }
      // if (!seo_d) {
      //   this.$notify.error({ title: "请输入seo描述" });
      //   return false;
      // }
      // if (!seo_k) {
      //   this.$notify.error({ title: "请输入seo关键词" });
      //   return false;
      // }
      this.seoInfo.case_icon = this.seoInfo.case_img.join();
      this.seoInfo.case_sub_icon = this.seoInfo.case_sub_img.join();
      this.seoInfo.banner = this.seoInfo.case_banner.join();
      return true;
    },
  },
};
</script>
<style lang="less" scoped>
.box-card {
  .form-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .icon_type {
      margin-right: 20px;
    }
  }
  .label {
    display: inline-block;
    width: 80px;
    flex-shrink: 0;
  }
  .el-select {
    width: 300px;
  }
  .seo_set {
    margin: 20px 0;
  }
  .seo_wrap {
    display: flex;
    flex-wrap: wrap;
    border: 1px solid #ccc;
    margin: 20px 0;
    padding: 20px;
    .form-item {
      margin-left: 0;
      margin-right: 60px;
      .label {
        width: 80px;
      }
      .co_w {
        width: 66px;
      }
    }
  }
  .el-upload__tip {
    color: red;
  }
}
</style>
